var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"ModalOverlay"},[_c('div',{class:['Modal', {Loading: this.loading}],style:({'max-width': `${_vm.maxWidth}px`})},[_vm._t("default"),_c('div',{staticClass:"LoadingOverlay"},[_c('ui-loading')],1)],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }